import React from 'react';
import styles from './Background.module.css';
import '../styles/theme.css';

/*
  AIntro — the dark band used on the HOME page directly under the hero.
  Renders a single serif lead paragraph and the stats card (+12M lives,
  £2.4B programmes, plus caption).

  The "3 paragraph cards" block lives on the WHAT WE DO page now —
  see WhatWeDoHero.js.
*/
function BackgroundComponent() {
  return (
    <section className={styles['bg']}>
      <div className={styles['bg-inner']}>
        <p className={styles['bg-lead']}>
          <span className={styles['accent']}>Policy Pulse</span> is a
          knowledge-for-policy institute, partnering with governments and
          organisations to deliver research and policy innovations. We bridge
          cutting-edge knowledge with implementation in complex environments.
        </p>

        <div className={styles['stats']}>
          <div className={styles['stats-grid']}>
            <div className={styles['stat']}>
              <span className={styles['stat-num']}>+12M</span>
              <span className={styles['stat-suffix']}>Individuals</span>
            </div>
            <div className={styles['stat']}>
              <span className={styles['stat-num']}>£2.4B</span>
              <span className={styles['stat-suffix']}>Annually</span>
            </div>
          </div>
          <div className={styles['stats-caption']}>
            Scope of public programmes informed by our work
          </div>
        </div>
      </div>
    </section>
  );
}

export default BackgroundComponent;
